// Maps AIC family strings to OTA portal model names used in software_model_match.
// ponytail: simple lookup, no regex — extend here when AIC adds new variants.
const FAMILY_AIC_TO_MODEL: Record<string, string> = {
  'FAEMINA': 'Faemina',
  'E71': 'E71 Touch',
  'E71E': 'E71E',
  'M100 RE': 'M100RE',
  'M200': 'M200',
  'M26': 'M26',
  'M26 BE': 'M26',
  'M26 SE': 'M26',
  'M26 TE': 'M26',
  'M26 TE COMPACT': 'M26',
  'M39': 'M39',
  'M40': 'M40',
  'PRESIDENT': 'President',
  'President': 'President',
  'PRESTIGE': 'Prestige',
  'PRESTIGE COMP': 'Prestige',
  'PRESTIGE PLUS': 'Prestige',
  'PRESTIGE+': 'Prestige',
};

/**
 * Translates a raw AIC familyAic string into the OTA portal model name
 * used for software version lookups. Falls back to the input value unchanged
 * so existing behaviour is preserved for unmapped entries.
 */
export function familyAicToModel(familyAic: string): string {
  return FAMILY_AIC_TO_MODEL[familyAic] ?? familyAic;
}

const MENDER_FAMILIES = ['s-series', 'supera'];
const TRADITIONAL_FAMILIES = ['idea', 'iot base module'];

export type DeploymentMethod = 'mender' | 'traditional' | 'unknown';

export function isMenderFamily(family: string): boolean {
  return MENDER_FAMILIES.includes(family.toLowerCase());
}

export function isTraditionalFamily(family: string): boolean {
  return TRADITIONAL_FAMILIES.includes(family.toLowerCase());
}

export function resolveDeploymentMethod(family: string): DeploymentMethod {
  const normalized = family.toLowerCase();
  if (MENDER_FAMILIES.includes(normalized)) return 'mender';
  if (TRADITIONAL_FAMILIES.includes(normalized)) return 'traditional';
  return 'unknown';
}

export function filterMenderFamilies(families: string[]): string[] {
  return families.filter(f => !isMenderFamily(f));
}
